import { render } from "./FormHypothesisAnalysis.vue?vue&type=template&id=0cf57365"
import script from "./FormHypothesisAnalysis.vue?vue&type=script&lang=js"
export * from "./FormHypothesisAnalysis.vue?vue&type=script&lang=js"
script.render = render

export default script